export const capitalize = (s?: string): string | undefined =>
  s ? s.replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase())) : undefined
